import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import createRoleFeatures from '@ad-scripts/domain/factories/configuration/create_role_features';

const initialState = {};

const roleFeaturesSlice = createSlice({
  name: 'roleFeatures',
  initialState,
  reducers: {
    update(state, action: PayloadAction) {
      return createRoleFeatures(action.payload);
    },
  },
});

const { update } = roleFeaturesSlice.actions;
export { update };
export default roleFeaturesSlice;
